const ShimmerTrendingProducts = ({ count = 10 }) => {
  return (
    <section className="sm:mt-10 mt-5 px-4 sm:px-6 animate-pulse">
      
      {/* Header */}
      <div className="mb-4 flex justify-between items-center">
        <div>
          <div className="h-6 w-40 bg-slate-200 rounded mb-2"></div>
          <div className="h-4 w-56 bg-slate-200 rounded"></div>
        </div>
        <div className="h-9 w-24 bg-slate-200 rounded-full"></div>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-5">
        {[...Array(count)].map((_, i) => (
          <div
            key={i}
            className="overflow-hidden rounded-xl bg-white shadow-sm"
          >
            {/* Image */}
            <div className="aspect-product-desktop w-full bg-slate-200"></div>

            {/* Content */}
            <div className="px-3 py-2 space-y-2">
              <div className="h-3 w-3/4 bg-slate-200 rounded"></div>
              <div className="h-3 w-2/3 bg-slate-200 rounded"></div>

              {/* Price */}
              <div className="flex gap-2">
                <div className="h-4 w-16 bg-slate-200 rounded"></div>
                <div className="h-3 w-12 bg-slate-200 rounded"></div>
              </div>

              {/* Buttons */}
              <div className="flex gap-2 mt-2">
                <div className="flex-1 h-8 bg-slate-200 rounded"></div>
                <div className="h-8 w-8 bg-slate-200 rounded"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ShimmerTrendingProducts;